
export default {
  name: 'AppIntersection',
  props: {
    options: {
      type: Object,
      default: () => {}
    },
    once: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    observer: null
  }),
  mounted() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit('intersect');
        if (this.once) this.observer.disconnect();
      }
    }, this.options);
    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    this.observer.disconnect();
  }
};
